import { apiClient, apiClientFormData, marketingApiClient as marketingClient } from './api';
/* ─── Automation Configs ─── */
export const getAutomationConfigs = (franchiseId) => marketingClient.get(`automation/${franchiseId}`).then((r) => r.data);
export const upsertAutomationConfig = (franchiseId, dto) => marketingClient.put(`automation/${franchiseId}`, dto).then((r) => r.data);
export const toggleAutomationConfig = (id) => marketingClient.patch(`automation/config/${id}/toggle`).then((r) => r.data);
export const getAutomationLogs = (configId, limit = 50, offset = 0) => marketingClient
    .get(`automation/config/${configId}/logs`, { params: { limit, offset } })
    .then((r) => r.data);
export const forceRunAutomations = () => marketingClient.post('automation/run').then((r) => r.data);
/* ─── Email Templates ─── */
export const getEmailTemplatesMeta = () => marketingClient.get('email-templates/meta').then((r) => r.data);
export const getEmailTemplates = (franchiseId) => marketingClient.get(`email-templates/${franchiseId}`).then((r) => r.data);
export const getEmailTemplate = (franchiseId, key, locale) => marketingClient.get(`email-templates/${franchiseId}/${key}/${locale}`).then((r) => r.data);
export const upsertEmailTemplate = (franchiseId, key, locale, dto) => marketingClient
    .put(`email-templates/${franchiseId}/${key}/${locale}`, dto)
    .then((r) => r.data);
export const previewEmailTemplate = (franchiseId, key, locale, dto) => marketingClient
    .post(`email-templates/${franchiseId}/${key}/${locale}/preview`, dto)
    .then((r) => r.data);
export const deleteEmailTemplate = (franchiseId, key, locale) => marketingClient
    .delete(`email-templates/${franchiseId}/${key}/${locale}`)
    .then((r) => r.data);
/* ─── Marketing Content (Blog, FAQ, Gallery, etc.) ─── */
/* Note: These are handled by the main Framework Server (port 3002) */
export const getBlogPosts = (franchiseId, status) => apiClient.get(`v1/marketing/blog/${franchiseId}`, { params: { status } }).then((r) => r.data);
export const getBlogPost = (franchiseId, id) => apiClient.get(`v1/marketing/blog/detail/${id}`).then((r) => r.data);
export const saveBlogPost = (dto) => apiClient.post(`v1/marketing/blog`, dto).then((r) => r.data);
export const deleteBlogPost = (id) => apiClient.delete(`v1/marketing/blog/${id}`).then((r) => r.data);
export const getFaqs = (franchiseId) => apiClient.get(`v1/marketing/faq/${franchiseId}`).then((r) => r.data);
export const createFaq = (dto) => apiClient.post(`v1/marketing/faq`, dto).then((r) => r.data);
export const updateFaq = (id, dto) => apiClient.put(`v1/marketing/faq/${id}`, dto).then((r) => r.data);
export const deleteFaq = (id) => apiClient.delete(`v1/marketing/faq/${id}`).then((r) => r.data);
export const getGallery = (franchiseId) => apiClient.get(`v1/marketing/gallery/${franchiseId}`).then((r) => r.data);
export const saveGalleryItem = (dto) => apiClient.post(`v1/marketing/gallery`, dto).then((r) => r.data);
export const deleteGalleryItem = (id) => apiClient.delete(`v1/marketing/gallery/${id}`).then((r) => r.data);
export const getTraiteurRequests = (franchiseId) => apiClient.get(`v1/marketing/traiteur/${franchiseId}`).then((r) => r.data);
export const getTraiteurConfig = (restaurantId, franchiseId) => apiClient.get(`v1/traiteur/config`, { params: { restaurantId, franchiseId } }).then((r) => r.data);
export const saveTraiteurConfig = (dto) => apiClient.post(`v1/traiteur/config`, dto).then((r) => r.data);
/* ─── Reviews ─── */
export const getReviews = (franchiseId, admin = false) => apiClient.get(`v1/marketing/reviews/${franchiseId}`, { params: { admin } }).then((r) => r.data);
export const createReview = (dto) => apiClient.post(`v1/marketing/reviews`, dto).then((r) => r.data);
export const updateReview = (id, dto) => apiClient.put(`v1/marketing/reviews/${id}`, dto).then((r) => r.data);
export const deleteReview = (id) => apiClient.delete(`v1/marketing/reviews/${id}`).then((r) => r.data);
export const getMarketingSettings = async (franchiseId) => {
    const response = await marketingClient.get(`/settings/${franchiseId}`);
    return response.data;
};
export const updateMarketingSettings = async (franchiseId, settings) => {
    const response = await marketingClient.put(`/settings/${franchiseId}`, settings);
    return response.data;
};
export const getSenderStatus = async (franchiseId) => {
    const response = await marketingClient.get(`/settings/status/${franchiseId}`);
    return response.data;
};
export const activateMailjetService = async (franchiseId) => {
    const response = await marketingClient.post(`/settings/activate/${franchiseId}`);
    return response.data;
};
export const uploadGalleryImage = async (franchiseId, file, category) => {
    const formData = new FormData();
    formData.append("image", file);
    formData.append("category", category);
    formData.append("franchiseId", franchiseId);
    // On utilise l'apiClientFormData défini dans api.ts pour le support multipart
    const response = await apiClientFormData.post(`/v1/marketing/gallery/upload`, formData);
    return response.data;
};
/* ─── Analytics ─── */
export const getAttributionStats = (franchiseId, days = 30) => marketingClient.get(`analytics/dashboard/${franchiseId}`, { params: { days } }).then((r) => r.data);
